import s from './Hero.module.css';

interface Props {
  onTrialClick: () => void;
  onPricingClick: () => void;
}

export function Hero({ onTrialClick, onPricingClick }: Props) {
  return (
    <section id="hero" className={s.hero}>
      <div className={s.content}>
        <h1 className={s.title}>
          不動産業務を、<br />
          <span className={s.titleAccent}>ワンストップで革新する。</span>
        </h1>
        <p className={s.subtitle}>
          物件管理・顧客CRM・電子契約・ポータル入稿を
          <br />
          ひとつのプラットフォームに。
        </p>
        <div className={s.buttons}>
          <button className={s.primary} onClick={onTrialClick}>
            無料トライアル開始
          </button>
          <button className={s.secondary} onClick={onPricingClick}>
            料金プランを見る
          </button>
        </div>
      </div>
    </section>
  );
}
